<section class="calibration">
    <!-- <div class="remind remind0"> Description description description description description description description description description description description description</div> -->
    <!-- <div class="remind">popup_table_date : {{state.popup_table_date}}</div> -->
    <!-- <div class="remind">dataToMulti : {{state.dataToMulti}}</div> -->
    <!-- <div class="remind">dataToMulti : {{state.group_op.length}}</div> -->
    <div class="radio radio0">
        <Radio class="input" v-model:selected="state.scaleType" @onClickRadio="onClickR" name="000" value="Devices" :text="$t('__d7d_n17r.__devices')" :isDisable="false"></Radio>
        <Radio class="input" v-model:selected="state.scaleType" @onClickRadio="onClickR" name="000" value="Groups" :text="$t('__d7d_n17r.__groups')"  :isDisable="false"></Radio>
    </div>
    <div class="device">
        <CollapseMultiSelect @showModal="showModal" :data="state.dataToMulti" :scaleType="state.scaleType"></CollapseMultiSelect>
        <!--  -->
    </div>
    <!-- <div>{{state.nextTitle}}</div> -->
    <!-- <div>{{state.selectedVal}}</div> -->
    <div class="radio">
        <Radio class="input" v-model:selected="state.selectedVal" name="001" :value="USERMODE[0]" :text="t('__d4e_m8t.__presetMode', {brand: brand})" :isDisable="state.disable_all||state.card.length==0"></Radio>
        <Radio class="input" v-model:selected="state.selectedVal" name="001" :value="USERMODE[1]" :text="t('__d4e_m8t.__userMode') + ' 1'" :isDisable="state.disable_all"></Radio>
        <Radio class="input" v-if="state.APICalibrationData?.model?.user_mode >=2" v-model:selected="state.selectedVal" name="001" :value="USERMODE[2]" :text="t('__d4e_m8t.__userMode') + ' 2'" :isDisable="state.disable_all"></Radio>
        <Radio v-if="state.APICalibrationData?.model?.user_mode >= 3" class="input" v-model:selected="state.selectedVal" name="001" :value="USERMODE[3]" :text="t('__d4e_m8t.__userMode') + ' 3'" :isDisable="state.disable_all"></Radio>
    </div>
    <div class="userModeBlock" v-if="state.selectedVal == USERMODE[1] ||state.selectedVal == USERMODE[2] ||state.selectedVal == USERMODE[3]">
        <div class="remind">{{t('__c3r_c9n.__theCalibrationResultWillOverwrite', {brand: brand})}}</div>
        <!-- 1. Apply Target Settings -->
        <div class="chose">
            <div class="outside">
                <div class="title">{{t('__c3r_c9n.__applyTargetSettings')}}</div>
                <Select class="select" :options="state.target_op" v-model:selected="state.target" :isError="false" :isDisable="state.disable_all"></Select>
            </div>
        </div>
        
        <!-- 2. EOTF -->
        <div class="chose">
            <div class="outside">
                <div class="title">{{t('__d4e_m8t.__eotf')}}</div>
                <Select class="select" :options="state.EOTF_op" v-model:selected="state.EOTF" :isError="false" :isDisable="state.disable_all"></Select>
            </div>
        </div>
        
        <!-- 3. Gamma -->
        <Slidebar class="sliderbar bold-title" :disable="state.disable_all" v-if="state.gamma_data.length>0" :title="t('__c3d_t4t.__gamma')" 
            :startValue="state.gamma_start" :data="state.gamma_data" unit="" :disableInput="true"
            :right_fix="state.gamma_fix_right" @onChange="gamma_change" :dot="state.gamma_dot"></Slidebar>
        
        <!-- 4. Brightness Lmax -->
        <Slidebar class="sliderbar bold-title" :disable="state.disable_all" v-if="state.brightness_max_data.length>0" :title="state.EOTF.text=='DICOM'? t('__d4e_m8t.__brightnessLmax') : t('__d4e_m8t.__brightnessLmax')" 
            :startValue="state.brightness_max_start" :data="state.brightness_max_data" unit=" cd/m²" :right_fix="state.brightness_max_fix_right" @onChange="brightness_max_change" :max="state.brightness_max_max" :min="state.brightness_max_min" :max_value="state.bright_max" :min_value="state.bright_min"></Slidebar>
        
        <!-- 5. Brightness Lmin -->
        <Slidebar class="sliderbar bold-title" :disable="state.disable_all" v-if="state.brightness_min_data.length>0" :title="state.EOTF.text=='DICOM'? t('__d4e_m8t.__brightnessLmin') : t('__d4e_m8t.__brightnessLmin')" 
            :startValue="state.brightness_min_start" :data="state.brightness_min_data" unit=" cd/m²" :disableInput="true"
            :right_fix="state.brightness_min_fix_right" @onChange="brightness_min_change" :max="state.brightness_min_max" 
            :min="state.brightness_min_min" :max_value="state.bright_max" :min_value="state.bright_min" :dot="state.brightness_min_dot"></Slidebar>
        
        <!-- 6. Gamut -->
        <div class="chose gamut-section">
            <div class="outside gamut-outside">
                <div class="title">{{t('__c3d_t4t.__colorGamut')}}</div>
                <div class="gamut-radio-block">
                    <div class="gamut-option-block standard-option">
                        <Radio class="input" v-model:selected="state.gamutType" name="gamutType" value="standard" 
                        :text="t('__c3d_t4t.__standardValue')" :isDisable="state.disable_all" @onClickRadio="gamutTypeOnChange"></Radio>
                        <div class="standard-gamut">
                            <Select class="select" :options="filteredGamutOp" v-model:selected="state.gamut" @onChange="gamutOnChange" :isError="false" :isDisable="state.disable_all || state.gamutType !== 'standard'"></Select>
                        </div>
                    </div>
                    
                    <div class="gamut-option-block">
                        <Radio class="input" v-model:selected="state.gamutType" name="gamutType" value="customized" 
                        :text="t('__c3d_t4t.__customizedGamut')" :isDisable="state.disable_all" @onClickRadio="gamutTypeOnChange"></Radio>
                        <div class="customized-gamut">
                            <div class="coordinate-inputs">
                                <div class="color-coordinate">
                                    <span class="color-label">{{t('__c3d_t4t.__red')}}</span>
                                    <div class="coordinate-row">
                                        <span>x:</span>
                                        <Input class="coordinate-input" v-model:value="state.customGamut.red.x" 
                                        type="text" :isDisable="state.disable_all || state.gamutType !== 'customized'" placeholder="0.5500-0.7080" @input="handleCoordinateInput('red', 'x', $event)" @onChange="handleCoordinateBlur('red', 'x', $event)"></Input>
                                        <span>y:</span>
                                        <Input class="coordinate-input" v-model:value="state.customGamut.red.y" 
                                        type="text" :isDisable="state.disable_all || state.gamutType !== 'customized'" placeholder="0.2500-0.4000" @input="handleCoordinateInput('red', 'y', $event)" @onChange="handleCoordinateBlur('red', 'y', $event)"></Input>
                                    </div>
                                </div>
                                <div class="color-coordinate">
                                    <span class="color-label">{{t('__c3d_t4t.__green')}}</span>
                                    <div class="coordinate-row">
                                        <span>x:</span>
                                        <Input class="coordinate-input" v-model:value="state.customGamut.green.x" 
                                        type="text" :isDisable="state.disable_all || state.gamutType !== 'customized'" placeholder="0.1500-0.4000" @input="handleCoordinateInput('green', 'x', $event)" @onChange="handleCoordinateBlur('green', 'x', $event)"></Input>
                                        <span>y:</span>
                                        <Input class="coordinate-input" v-model:value="state.customGamut.green.y" 
                                        type="text" :isDisable="state.disable_all || state.gamutType !== 'customized'" placeholder="0.5000-0.7970" @input="handleCoordinateInput('green', 'y', $event)" @onChange="handleCoordinateBlur('green', 'y', $event)"></Input>
                                    </div>
                                </div>
                                <div class="color-coordinate">
                                    <span class="color-label">{{t('__c3d_t4t.__blue')}}</span>
                                    <div class="coordinate-row">
                                        <span>x:</span>
                                        <Input class="coordinate-input" v-model:value="state.customGamut.blue.x" 
                                        type="text" :isDisable="state.disable_all || state.gamutType !== 'customized'" placeholder="0.1310-0.2000" @input="handleCoordinateInput('blue', 'x', $event)" @onChange="handleCoordinateBlur('blue', 'x', $event)"></Input>
                                        <span>y:</span>
                                        <Input class="coordinate-input" v-model:value="state.customGamut.blue.y" 
                                        type="text" :isDisable="state.disable_all || state.gamutType !== 'customized'" placeholder="0.0460-0.1700" @input="handleCoordinateInput('blue', 'y', $event)" @onChange="handleCoordinateBlur('blue', 'y', $event)"></Input>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 7. White Point -->
        <div class="chose sliderBlock">
            <div class="outside">
                <div class="title">{{t('__c3r_c9n.__whitePoint')}}</div>
            </div>
        </div>
        <div class="radioBlock">
            <div class="flex" >
                <Radio class="input" v-model:selected="safeWhitePointSelect" name="003" value="standard" 
                :text="t('__c3d_t4t.__standardValue')" :isDisable="state.disable_all" @onClickRadio="whitePointSelectOnChange"></Radio>
                <div class="standard-select-container">
                    <Select class="select" :options="state.color_standard_op || []" v-model:selected="state.color_standard" @onChange="colorStandardOnChange" :isError="false" :isDisable="state.disable_all || safeWhitePointSelect !== 'standard'"></Select>
                </div>
            </div>
            <div class="flex">
                <Radio class="input" v-model:selected="safeWhitePointSelect" name="003" value="coordinate" 
                :text="t('__d4e_m8t.__coordinate')" :isDisable="state.disable_all" @onClickRadio="whitePointSelectOnChange"></Radio>
                <div>
                    <span :class="{'disable':state.disable_all || safeWhitePointSelect !== 'coordinate'}">x : </span> 
                    <Input  class="select_ui coordinate-x" v-model:value="state.coordinate.x"
                    :minInt="state.coordinateEnum.XMin" :maxInt="state.coordinateEnum.XMax"
                    type="number" :isDisable="state.disable_all || safeWhitePointSelect !== 'coordinate'"></Input>
                    
                    <span :class="{'disable':state.disable_all || safeWhitePointSelect !== 'coordinate'}">y : </span>
                    <Input class="select_ui" v-model:value="state.coordinate.y" 
                    :minInt="state.coordinateEnum.YMin" :maxInt="state.coordinateEnum.YMax"
                    type="number" :isDisable="state.disable_all || safeWhitePointSelect !== 'coordinate'"></Input>
                </div>
            </div>
            <div class="flex">
                <Radio class="input" v-model:selected="safeWhitePointSelect" name="003" value="colorTemperature" 
                :text="t('__d4e_m8t.__colorTemperature')" :isDisable="state.disable_all" @onClickRadio="whitePointSelectOnChange"></Radio>
                <Slidebar :disable="state.disable_all || safeWhitePointSelect !== 'colorTemperature'" v-if="state.temperature_data.length>0" :startValue="state.temperature_start" 
                    :data="state.temperature_data" unit=" K" @onChange="temperature_change" :max="state.temperature_max" :min="state.temperature_min" :lock="state.temperature_lock" :isTemperature="true"></Slidebar>
                    
            </div>
           
        </div>
    </div>
    <div>{{}}</div>
    <div v-if="state.selectedVal == USERMODE[0]">
        <!-- 0705 -->
        <div class="remind">{{t('__popup.__presetModeWillBeCalibrated', { brand: brand })}}</div>
        <div class="remind">{{t('__popup.__noticePresetHdrMode')}}</div>
        <div class="card">
          <Cardimg v-for="(item, index) in state.card" class="cardimg" :class="index%2==1?'right':'',index!=0&&index!=1?'top':''"  
          :star="item.color_range == 'HDR'"  :name="item.name" icon="asus_proart_sw_ico_color" :gamma="item.gamma" 
          :color="item.color" :brightness="item.brightness" v-model:isCheck="item.click"></Cardimg>
        </div>
    </div>
    <div class="btn">
        <Button class="btn-next" @onClick="onClick" :text="t('__common.__next')" :disable="state.disable_all"></Button>
    </div>
</section>